/**
 * v0.19.18 — 「分区卡片」骨架的**共用入口** (本仓铁律「一个逻辑一个入口, 不许抄两遍」)
 *
 * ## v0.19.20 (批 41 · 段②) — 实现**搬**进 `utils/FormPrimitives.js`
 *   `renderSection` 原来在本文件里 (v0.19.18 为「新建客户跟进」/「我的卡片」两个弹层抽的),
 *   批 41 段②把 `renderSection` / `fieldIcon` / `errText` 三个表单原语**收敛成一个入口**
 *   ⇒ 实现搬进 `utils/FormPrimitives.js`, 本文件只留**一行 re-export**。
 *   ⛔ **本文件不许删**: `MyCardDetailModal.js` 与 `SalesFollowupCreateModal.js` 正 import 它
 *     (那两个是批 39 已上线的产物) ⇒ 保留这一行 re-export ⇒ 两个既有 importer **一个字都不用改**。
 */

/**
 * 一段分区。 (实现见 `utils/FormPrimitives.js` —— v0.19.20 搬走)
 */
import {  renderSection  } from './FormPrimitives';
export {  renderSection  };
flarum.reg.add('ziiven-ziven-scheduler', 'forum/utils/FollowupForm', { renderSection: renderSection, });